import { addSubjectPlaceholder } from './SubjectLine.locstring.json';
import loc from 'owa-localize';
/* tslint:disable:jsx-no-lambda WI:47713 */
import ImportanceIcon from './ImportanceIcon';
import { observer } from 'mobx-react-lite';
import { Icon } from '@fluentui/react/lib/Icon';
import { ITextField, TextField } from '@fluentui/react/lib/TextField';
import { ControlIcons } from 'owa-control-icons';
import updateLastFocusedControl from 'owa-addins-editor-plugin/lib/actions/updateLastFocusedControl';
import updateSubject from 'owa-mail-compose-actions/lib/actions/updateSubject';
import updateSubjectSelectionRange from 'owa-addins-editor-plugin/lib/actions/updateSubjectSelectionRange';
import { ComposeViewState } from 'owa-mail-compose-store';
import { LastFocusedControl } from 'owa-editor-addin-plugin-types/lib/utils/AddinViewState';
import { UIEnabledState } from 'owa-mail-compose-store';
import * as React from 'react';
import { DarkModeContext } from 'owa-theme';

const styles = require('./ComposeTop.scss');
const MAX_SUBJECT_LENGTH = 255;

export interface SubjectLineProps {
    composeViewState: ComposeViewState;
}

export default observer(
    function SubjectLine(props: SubjectLineProps, ref: React.Ref<ITextField>) {
        const container = React.useRef<HTMLDivElement>();
        const subjectInput = React.useRef<ITextField>();

        const isDarkMode = React.useContext(DarkModeContext);

        const updateSelectionRange = React.useCallback(() => {
            const { subject } = props.composeViewState.addin;
            const { selectionStart, selectionEnd } = subjectInput.current;
            if (selectionStart != subject.selectionStart || selectionEnd != subject.selectionEnd) {
                updateSubjectSelectionRange(
                    props.composeViewState.addin.subject,
                    selectionStart,
                    selectionEnd
                );
            }
        }, [props.composeViewState]);

        React.useEffect(updateSelectionRange, []);

        const onSubjectChange = React.useCallback(
            (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue: string) => {
                updateSubject(props.composeViewState, newValue);
            },
            [props.composeViewState]
        );

        const onSubjectInputFocus = React.useCallback(() => {
            updateLastFocusedControl(props.composeViewState.addin, LastFocusedControl.SubjectLine);
        }, [props.composeViewState]);

        const { subject, importance, smimeViewState } = props.composeViewState;
        const isDisabled = props.composeViewState.uiEnabledState === UIEnabledState.AllDisabled;

        return (
            <div className={styles.subjectContainer} ref={container}>
                <div className={styles.subjectIconContainer}>
                    <ImportanceIcon importance={importance} />
                </div>
                <div className={styles.subjectLine}>
                    <TextField
                        componentRef={subjectInput}
                        className={styles.subject}
                        value={subject}
                        inputClassName={isDarkMode && styles.darkModeInput}
                        maxLength={MAX_SUBJECT_LENGTH}
                        borderless={true}
                        autoComplete={'off'}
                        type={'text'}
                        spellCheck={true}
                        placeholder={loc(addSubjectPlaceholder)}
                        ariaLabel={loc(addSubjectPlaceholder)}
                        onChange={onSubjectChange}
                        onSelect={updateSelectionRange}
                        onFocus={onSubjectInputFocus}
                        readOnly={isDisabled}
                    />
                    {smimeViewState?.shouldSignMessageAsSmime && (
                        <Icon iconName={ControlIcons.Ribbon} className={styles.ribbonIcon} />
                    )}
                    {smimeViewState?.shouldEncryptMessageAsSmime && (
                        <Icon iconName={ControlIcons.Lock} className={styles.lockIcon} />
                    )}
                </div>
            </div>
        );
    },
    { forwardRef: true }
);
